import { getStatus } from "core-integration/src/store/game/reducers";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatRawAsLocal } from "shared-utils/src/datetime";
import styles from "./lastUpdated.module.css";

const LastUpdated = () => {
  const { t } = useTranslation("priceChanges");
  const status = useSelector(getStatus);

  const lastUpdatedTime = status?.price_change_last_updated;

  if (!lastUpdatedTime) {
    return null;
  }

  return (
    <div className={styles.lastUpdatedWrapper}>
      <div className={styles.lastUpdatedInner}>
        {t("lastUpdated", "Last updated")}: {formatRawAsLocal(lastUpdatedTime)}
      </div>
      <p className={styles.updateNote}>
        {t("note", "(Updates every 15 minutes)")}
      </p>
    </div>
  );
};

export default LastUpdated;
